export default "__VITE_ASSET__E9bC0yfr__ 400w, __VITE_ASSET__QRGs5nzg__ 800w, __VITE_ASSET__DnanpTYt__ 1200w";